<template>
  <div>
    <div>{{ msg }}</div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      msg: '三個臭皮匠，勝過一個諸葛亮'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue